import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

const Card = ({ proportional, label, customLabelClass, children, cardClass, cardContainerClass, id, onClick }) => (
  <div id={id || ''} onClick={onClick} className={classNames({
    [styles.cardContainer]: true,
    [cardContainerClass]: cardContainerClass
  })}>
    {label && (
      <span
        className={classNames({
          [styles.label]: true,
          [customLabelClass]: !!customLabelClass,
          "text-ghost": !customLabelClass
        })}
      >
        {label}
      </span>
    )}
    <div className={classNames({
      [styles.card]: true,
      [styles.withLabel]: label,
      [styles.proportional]: proportional,
      [cardClass]: cardClass,
      [styles.safariTen]: navigator.vendor.toLowerCase().indexOf('apple') > -1 && navigator.userAgent.indexOf('10') > -1
    })}>
      {children}
    </div>
  </div>
);

export default Card;
